"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    display: 'inline-block',
    cursor: 'pointer',
    rippleBorderRadius: '50%',
    idleIconFx: {
      opacity: 0.38
    },
    hoverIconFx: {
      opacity: 0.87
    },
    activeIconFx: {
      opacity: 1
    },
    disabledIconFx: {
      opacity: 0.24
    },
    idleRippleFx: {
      transform: 'scale(0)',
      opacity: 0
    },
    hoverRippleFx: {
      transform: 'scale(1.33)',
      opacity: 0.08
    },
    activeRippleFx: {
      transform: 'scale(1.33)',
      opacity: 0.24
    }
  };
}